import { useEffect, useState, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css"; 
import SearchBox from "./components/SearchBox"; 
import { Row, Container, Col, Button } from "react-bootstrap";
import { getVideoInformation } from "./api/appApi";
import { Routes, Route } from "react-router-dom";
import SearchContainer from "./container/SearchContainer"; 
import DownloadContainer from "./container/DownloadContainer"; 
import { useNavigate, useLocation } from "react-router-dom";
import queryString from "query-string";
import { FaArrowUp } from "react-icons/fa";
import Header from "./components/Header";

const SEARCH_TYPE = "SEARCH_DATA";
const INFO_TYPE = "VIDEO_INFO";

function App() {
  const [data, setData] = useState({});
  const [searchData, setSearchData] = useState({});
  const [searchValue, setSearchValue] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [error, setError] = useState("");
  const [showScrollTop, setShowCrollTop] = useState(false);
  const [isLoadMore, setIsLoadMore] = useState(false);

  const yRef = useRef({ current: { y: 0 } });
  let navigate = useNavigate();
  let location = useLocation();

  useEffect(() => {
    if (location.search && location.pathname !== "/download") {
      const search = queryString.parse(location?.search);
      setSearchValue(search?.query);
    }
  }, [location]);

  useEffect(() => {
    const handleNavigation = (e) => {
      const window = e.currentTarget;
      // Dùng logic đơn giản hơn: chỉ hiện khi cuộn xuống và > 200px
      if (window.scrollY > 200) {
        setShowCrollTop(true);
      } else {
        setShowCrollTop(false);
      }
      yRef.current.y = window.scrollY;
    };
    window.addEventListener("scroll", handleNavigation);
    return () => window.removeEventListener("scroll", handleNavigation);
  }, []);
  const handleSearch = async (value) => {
    setIsSearching(true);
    const result = await getVideoInformation(value);
    setIsSearching(false);

    if (result?.error !== null) {
      setError(result?.error);
      setData({});
      setSearchData({});
      return;
    }

    if (result?.type === SEARCH_TYPE) {
      if (result?.payload?.items?.length === 0) {
        // Kiểm tra items length thay vì totalResults
        setError("Video not found");
        setSearchData({});
        setData({});
        return;
      }
      setSearchData(result?.payload || {});
      setError("");
      // Không cần navigate nếu đã ở trang search
      return;
    }
    if (result?.type === INFO_TYPE) {
      setData(result?.payload || {});
      setError("");
      // Chuyển hướng sang trang download
      navigate(`/download?query=${value}`, { replace: true });
      return;
    }
  };
  const handleSubmit = (value) => {
    handleSearch(value);
    navigate(`/search?query=${value}`);
  };

  const handleLoadMore = async () => {
    setIsLoadMore(true);
    const result = await getVideoInformation(
      `${searchValue}&pageToken=${searchData?.nextPageToken}`
    );
    setIsLoadMore(false);
    if (result?.payload?.items?.length > 0) {
      setSearchData({
        ...searchData,
        items: [...searchData?.items, ...result?.payload?.items],
        nextPageToken: result?.payload?.nextPageToken,
      });
    }
  };
  const goToHome = () => {
    setError("");
    navigate("/");
  };

  return (
    <div className="App">
      <Header />
      <Container className="flex-grow-1 py-4">
        <div className="text-center mb-5">
            <h1 className="fw-bold mb-2" style={{ cursor: 'pointer' }} onClick={goToHome}>Download YouTube Videos</h1>
            <p className="text-muted">Fast, easy, and free YouTube video downloader</p>
        </div>

        <Row className="justify-content-center mb-5">
            <Col xs={12} md={10} lg={8}>
                <SearchBox
                  onSubmit={handleSubmit}
                  isSearching={isSearching}
                  searchValue={searchValue}
                  setSearchValue={setSearchValue}
                />
            </Col>
        </Row>

        {error && (
            <div className="alert alert-danger text-center w-75 mx-auto" role="alert">
                {error}
            </div>
        )}

        <Routes>
          <Route
            path="/download"
            element={
              <DownloadContainer data={data} handleSearch={handleSearch} />
            }
          />
          <Route
            path="/search"
            element={
              <SearchContainer
                data={searchData}
                handleSearch={handleSearch}
                handleLoadMore={handleLoadMore}
                isLoadMore={isLoadMore}
              />
            }
          />
          <Route
            path="/"
            element={
              <div className="text-center text-muted mt-5">
                <p>Enter a YouTube link or search keyword above to get started.</p>
              </div>
            }
          />
        </Routes>
      </Container>

      <Button
        variant="danger"
        className={`scroll-top-btn ${!showScrollTop && "d-none"}`}
        onClick={() => {
          window.scrollTo({ top: 0, behavior: "smooth" }); 
        }}
      >
        <FaArrowUp size="20" />
      </Button>
    </div>
  );
}

export default App;
